webpackJsonp([130835895155560],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamor = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var divStyle = (0, _glamor.css)({
	  paddingTop: '40px',
	  textAlign: 'center'
	});
	
	var linkStyle = (0, _glamor.css)({
	  color: '#fffffff0',
	  textDecoration: 'none',
	  ':hover': {
	    color: '#cfcfcf'
	  }
	});
	
	var Releases = function Releases() {
	  return Glamor.createElement(
	    'div',
	    { className: divStyle },
	    Glamor.createElement(
	      'p',
	      null,
	      'Our full label discography is available for stream and purchase on our bandcamp page:',
	      Glamor.createElement('br', null),
	      Glamor.createElement(
	        'a',
	        { className: linkStyle, href: 'https://voodoodown.bandcamp.com/', target: '_blank' },
	        'https://voodoodown.bandcamp.com'
	      )
	    )
	  );
	};
	
	exports.default = Releases;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-releases-js-29302f677b5d7932915d.js